// 新协议
function kkmhhybrid_show_loading (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "show_loading",
    },
    param: {
      style: opt.style,
      show: opt.show
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

/**
 * 控制loading隐现状态/样式<br>
 * kkmhhybrid://show_loading，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=140118742}<br>
 * @param {Object} opt 参数对象
 * @param {Number} opt.style 控制loading样式 如果指定的style不存在或者不是数字使用默认loading样式 如果style目前不支持的情况默认loading样式 目前支持 1: 默认样式 ; 其它值带扩展
 * @param {Boolean} opt.show 控制loading的隐藏显示 只支Boolean值: true:显示loading false:隐藏loading
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function show_loading(opt, criticalAppVersion) {
  kkmhhybrid_show_loading(opt)
}

export default show_loading;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/show_loading/index.js